import { ActionCreatorWithPayload } from 'rxbeach';

export type CrudActions<Request, EntityType> = {
  apiGetItems: ActionCreatorWithPayload<string[]>;
  apiCreate: ActionCreatorWithPayload<Request[]>;
  apiPut: ActionCreatorWithPayload<EntityType[]>;
  apiDelete: ActionCreatorWithPayload<string[]>;

  setItems: ActionCreatorWithPayload<EntityType[]>;
  create: ActionCreatorWithPayload<EntityType[]>;
  put: ActionCreatorWithPayload<EntityType[]>;
  remove: ActionCreatorWithPayload<string[]>;
  error: ActionCreatorWithPayload<any>;
};

export type EntityTypeItem = { id: string };

export type CrudApiService<Request, EntityType> = {
  getAll: () => Promise<EntityType[]>;
  getItem: (id: string) => Promise<EntityType>;
  create: (body: Request) => Promise<EntityType>;
  put: (body: EntityType) => Promise<EntityType>;
  remove: (id: string) => any;
  handleApiError: (error: Error, defaultMessage: string) => string;
};

export enum ApiServiceState {
  READY = 'ready',
  SUCCESS = 'success',
  LOADING = 'loading',
  ERROR = 'error',
}
